import { NewDynamicTab } from "../../../components/Page";
import { HpgclTitle } from "../components";
import { TabSwitcher } from "../Hppc_Das";
// import { ProcYearly } from "./ProcYearly";
import HaryanaGnaTgna from "./GnaTgna copy";
import { HaryanaPowerProcurement
  
 } from "../../../config/DefaultDates";
import Appc from "./Appc";
export function HppcProcurement() {
  return (
    <NewDynamicTab
      showDates={true}
      header="Power Procurement"
      defaultDates={HaryanaPowerProcurement}
      headerPrefixComponent={<TabSwitcher />}
      middleComponent={<HpgclTitle />}
      tabs={{
        APPC :<Appc />,
        "GNA/TGNA": <HaryanaGnaTgna />,
      }}
    />
  );
}
